import React, { FC, memo, useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { getPathByPageId } from '@sportworld/js-sdk/src/utils/utils'

import { PageBackground } from '@/components/PageContent/PageBackground'
import { paths } from '@/constants/paths'
import { useFindNearestByImgWidth } from '@/hooks/useFindNearestByImgWidth'
import { useDeepLinkSwitcher } from '@/hooks/useOpenAppController'
import { getMainHomePath } from '@/utils/route'

import { ButtonBoxComponent } from './ButtonBoxComponent'
import { ContentBox, FeatureScreenWrapper } from './styles'

const FeatureScreenRaw: FC = () => {
  const navigate = useNavigate()
  const deepLinkSwitcher = useDeepLinkSwitcher()
  const featureScreenData = useLocation().state || {}
  const { featureScreen, deepLinkData } = featureScreenData

  useEffect(() => {
    if (!featureScreen) {
      const path = getMainHomePath()
      navigate(path)
    }
  }, [featureScreen])

  const screenImgSrc = useFindNearestByImgWidth(
    featureScreen?.image?.sources,
    1920,
  )?.url

  if (!featureScreen) {
    return null
  }

  const featureButtonLink = featureScreen.featureButtonLink
  const featureButtonTitle = featureScreen.featureButtonTitle
  const hasFeatureButton = Boolean(featureButtonLink && featureButtonTitle)

  const linkingButtonHandler = () => {
    if (!hasFeatureButton) {
      return
    }
    const path =
      getPathByPageId(featureButtonLink) || `${paths.PAGE}/${featureButtonLink}`
    navigate(path)
  }

  const continueButtonHandler = () => deepLinkSwitcher(deepLinkData)

  return (
    <FeatureScreenWrapper>
      <ContentBox>
        {screenImgSrc && <PageBackground src={screenImgSrc} />}
        <ButtonBoxComponent
          {...{
            hasFeatureButton,
            featureButtonTitle,
            linkingButtonHandler,
            continueButtonHandler,
          }}
        />
      </ContentBox>
    </FeatureScreenWrapper>
  )
}

export const FeatureScreen = memo(FeatureScreenRaw)
